import ViewUserDetailsImageContainer from "./ViewUserDetailsImageContainer";

export default ViewUserDetailsImageContainer;
